// extracted by css-extract-rspack-plugin
export default {"container":"zCWfxwQs","inner":"JIMYjuak","content":"IdupoLYw","mainText":"cEAj9S9p"};